import axios from 'axios';
import { auth, resError } from '@services/Helpers/ServiceInterceptor';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL + '/VReportsStaticPoolDetails/',
});

api.interceptors.request.use((config) => auth(config));
api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => resError(error)
);

class VReportsStaticPoolDetailsService {

    constructor() {
        if (!VReportsStaticPoolDetailsService.instance) {
            VReportsStaticPoolDetailsService.instance = this;
        }
        return VReportsStaticPoolDetailsService.instance;
    }

    search = (filters, orderBy, orderDir, p, fields, perPage) => {
        return api.post('/search', { filters: Object.keys(filters).length > 0 ? filters : null, orderBy, orderDir, page: p, fields: undefined, perPage: parseInt(perPage) });
    };

    export = (filters, orderBy, orderDir, p, fields, perPage) => {
        return api.post('/export', { filters: Object.keys(filters).length > 0 ? filters : {}, orderBy, orderDir, page: p, fields: undefined, perPage: parseInt(perPage) }, {
            responseType: 'blob',
        });
    }
   
}

const instance = new VReportsStaticPoolDetailsService();
Object.freeze(instance);

export default instance;